import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsProviderLoadSchema = withDefaults({
  type: 'pcs-provider-load',
  fields: [
    {
      kind: 'attribute',
      name: 'actual',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'cover',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCompanyLoads',
      type: 'pcs-company-load',
      options: {
        async: false,
        inverse: 'pcsProviderLoad',
      },
    },
  ],
});

export default PcsProviderLoadSchema;
